// @flow
export const TABLET_MIN_SCREEN_SIZE = 768
